import React, { useState, ReactElement, Component, useEffect, useContext } from "react";
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'antd';
// import { left_menu_item, LeftMenuContext } from "../../contexts/left-menu";
import { Link, withRouter } from 'react-router-dom';
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";

const UseMenu = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  // const left_menu_items: left_menu_item[] = useContext(LeftMenuContext)[0];
  const [active_key, set_active_key]: [string, React.Dispatch<React.SetStateAction<string>>] = useState('');
  const user_info: IUserInfoType = useContext(UserInfoContext)[0];
  const path = props.history.location.pathname.substring(1).substring(props.history.location.pathname.substring(1).indexOf('/') + 1);
  const menu_new: JSX.Element[] = [];

  useEffect(() => {
    // active_key === "" && !path.includes("service-usage") && set_active_key("kubernetes");
    // path.includes("service-usage") && set_active_key("service-usage");
    if (path.includes("service-usage")) {
      set_active_key("service-usage")
    } else {
      set_active_key("kubernetes")
    }
    // set_active_key(path);
  }, [active_key, path]);

  // if (left_menu_items.length > 0) {
  //   for (let i = 0; i < left_menu_items.length; i++) {
  //     const menu_item: any = left_menu_items[i].key;
      menu_new.push(
        <div className="w-100">
          {user_info.role && <Col sm={24} className="mt-10" key="kubernetes">
            <Link to={`/monitor/kubernetes`}>
              <div className={`left_menu_button w-110 ${active_key === "kubernetes" ? 'active' : ''} text-left`} onClick={() => { set_active_key("kubernetes") }}>Kubernetes</div>
            </Link>
          </Col>}
          {<Col sm={24} className="mt-10" key="service-usage">
            <Link to={`/monitor/service-usage`}>
              <div className={`left_menu_button w-110 ${active_key === "service-usage" ? 'active' : ''} text-left`} onClick={() => { set_active_key("service-usage") }}><FormattedMessage id="service_usage" /></div>
            </Link>
          </Col>}
        </div>
        
      )
  //   }
  // }

  return <Row>{menu_new}</Row>
}

export default withRouter(UseMenu);